import { Box, Grid, GridItem, Image, useStyleConfig, Link, Flex, Button } from '@chakra-ui/react';
import {  progressiveFormStepper } from '../../components/ProgressiveFormStepper/utils';
import SectionHeader from '../SectionHeader';
import BorderBox from '../../components/Wrappers/BorderBox';
import { parseResume, skipParse } from './utils';

const Parser = ({ props }) => {
  const sectionName = props.stateProps.sectionData.sectionName;
  const formikProps = props.formikProps;
  const stateProps = props.stateProps;
  const jobSeekerData = formikProps.values.jobSeekerData;
  const questions = props.sections['questions'];
  const variant = 'wrapper';
  const styles = useStyleConfig('Parser', { variant });
  const navSection = props.navSections[sectionName];

  return (
    <BorderBox props={props} sx={{ ...styles.wrapper }}>
      <Grid sx={{ ...styles.grid }} templateColumns={2}>
        <GridItem sx={{ ...styles.grid.hero }}>
          <Image sx={{ width: [0, 0, 0, 'auto'] }} src={navSection.hero} />
        </GridItem>
        <GridItem sx={{ ...styles.grid.fieldHeader }}>
          <SectionHeader navSection={navSection} props={props} />
          <Box sx={{ ...styles.grid.fieldContent }}>
            {Object.entries(jobSeekerData).map((secParts, index) => {
                return (progressiveFormStepper(props, questions, index));
              },
            )}
            {
              //ALERT Only show the menu link on the parse resume screen.
              //temporary to accomodate moving Career Summary here
              stateProps.step === 1 &&
            <Flex width='100%' justifyContent='space-between'>
              <Link
                display="block"
                color="blue"
                textDecoration="underline"
                onClick={((e) => {
                  skipParse(stateProps);
                })}>Menu &gt;&gt;</Link>
              <Button display='none' id='parseButton'
                      onClick={() => parseResume(props)}>
                Upload
              </Button>
            </Flex>
            }
          </Box>
        </GridItem>
      </Grid>
    </BorderBox>
  );
};

export default Parser;